import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import { Text } from './Texte';
import { colors, radius, spacing, typography } from '../theme/tokens';

interface TermsConsentProps {
  checked: boolean;
  onToggle: (next: boolean) => void;
  onOpenTerms: () => void;
  onOpenPrivacy: () => void;
  // Teinte des deux liens. Défaut électrique (inscription) ; le gate CGU passe le violet de sa
  // maquette. Optionnelle pour que les appelants existants restent identiques au pixel.
  linkColor?: string;
  testID?: string;
}

// Case à cocher + libellé avec liens cliquables. La case (tap) toggle ; les liens (tap) naviguent
// — séparés pour éviter le conflit tap-lien / tap-toggle.
export function TermsConsent({
  checked,
  onToggle,
  onOpenTerms,
  onOpenPrivacy,
  linkColor = colors.electric,
  testID,
}: TermsConsentProps) {
  return (
    <View style={styles.row}>
      <Pressable
        testID={testID}
        accessibilityRole="checkbox"
        accessibilityState={{ checked }}
        onPress={() => onToggle(!checked)}
        hitSlop={8}
        style={[styles.box, checked && styles.boxChecked]}
      >
        <Text style={styles.mark}>{checked ? '✓' : ''}</Text>
      </Pressable>
      <Text style={styles.label}>
        J’accepte les{' '}
        <Text testID={testID ? `${testID}-terms` : undefined} style={[styles.link, { color: linkColor }]} onPress={onOpenTerms}>
          conditions d’utilisation
        </Text>{' '}
        et la{' '}
        <Text testID={testID ? `${testID}-privacy` : undefined} style={[styles.link, { color: linkColor }]} onPress={onOpenPrivacy}>
          politique de confidentialité
        </Text>
        .
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  row: { flexDirection: 'row', alignItems: 'flex-start', gap: spacing.sm },
  box: {
    width: 22,
    height: 22,
    borderRadius: radius.sm,
    borderWidth: 2,
    borderColor: colors.grey400,
    alignItems: 'center',
    justifyContent: 'center',
  },
  boxChecked: { backgroundColor: colors.bluePrimary, borderColor: colors.bluePrimary },
  mark: { color: colors.white, fontSize: 14, lineHeight: 18, fontWeight: '700' },
  label: { flex: 1, fontSize: typography.small.size, lineHeight: typography.small.size + 6, color: colors.grey700 },
  link: { fontWeight: '700' }, // couleur fournie par linkColor (défaut électrique)
});
